(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("configureTierSystem", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/gamification/configureTierSystemView.html",
            controller: ["gamificationResource", "frameworkService", "messageService", "$state", "$translate", "_", ConfigureTierSystemCtrl],
            controllerAs: "vm"
        };
        function ConfigureTierSystemCtrl(gamificationResource, frameworkService, messageService, $state, $translate, _) {
            var vm = this;
            vm.loading = true;
            vm.formData = {};
            if (!frameworkService.data.tenantFeatures.gamificationTierSystem) {
                $state.go("main.notFound");
                return;
            }
            gamificationResource.getTierSystemViewModel(function (data) {
                vm.data = data;
                vm.copperTier = _.find(vm.data.systemTypes, function (tier) { return tier.name === "Copper"; });
                vm.data.systemTypes = _.without(vm.data.systemTypes, vm.copperTier);
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
            //////////////////////////////////////////////////////////////////
            vm.validateAndSaveForm = function (form, vm) {
                var systemTypes = _.map(vm.data.systemTypes, function (item) { return { id: item.id, value: parseInt(form.$data[item.id]), type: item.name }; });
                var types = _.groupBy(systemTypes, function (i) { return i.type; });
                if (types.Bronze[0].value < types.Silver[0].value && types.Silver[0].value < types.Gold[0].value &&
                    types.Gold[0].value < types.Platinum[0].value && types.Platinum[0].value < types.Diamond[0].value) {
                    var model = { gracePeriod: form.$data['gracePeriod'], systemTypes: systemTypes };
                    gamificationResource.updateTierSystem(model, function (data) {
                        vm.data = data;
                        vm.copperTier = _.find(vm.data.systemTypes, function (tier) { return tier.name === "Copper"; });
                        vm.data.systemTypes = _.without(vm.data.systemTypes, vm.copperTier);
                        messageService.success("common.changesSaved");
                    }, function (error) {
                        messageService.error(error);
                    });
                }
                else {
                    form.$valid = false;
                    return "error"; //this is not visible - just to keep the form open
                }
                return false;
            };
            vm.validateGracePeriod = function (data) {
                if (!data && data !== 0)
                    return $translate.instant("gamification.tierSystem.gracePeriod.error.required");
                else if (data < 1 || data > 999)
                    return $translate.instant("gamification.tierSystem.gracePeriod.error.limits");
                return false; //close the edit box without updating the model
            };
            vm.validatePercentCompletion = function (data) {
                if (!data && data !== 0)
                    return $translate.instant("gamification.tierSystem.percentCompletion.error.required");
                else if (data < 1 || data > 100)
                    return $translate.instant("gamification.tierSystem.percentCompletion.error.limits");
                return false; //close the edit box without updating the model
            };
            vm.clearErrors = function (form, field) {
                form.$setError(field.toString(), "");
            };
        }
    });
})();
